import { render, staticRenderFns } from "./wordNav.vue?vue&type=template&id=a844f88c&scoped=true"
import script from "./wordNav.vue?vue&type=script&lang=js"
export * from "./wordNav.vue?vue&type=script&lang=js"
import style0 from "./wordNav.vue?vue&type=style&index=0&id=a844f88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a844f88c",
  null
  
)

export default component.exports